/* eslint-disable */
import * as THREE from 'three'
import a from './p.js'
import r1 from './r1.js'
import { o411 } from './h.js'

var s = function (e) {
  function r(e, t, n) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r);
    var i = function (e, t) {
      if (!e)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t
    }(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e, t, n));
    return i.material.uniforms.u_originalImage.value.wrapS = THREE.RepeatWrapping,
      i.material.uniforms.u_time = {
        type: "f",
        value: 0
      },
      i.material.fragmentShader = o411,
      i
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(r, a.default),
    r1(r, [{
      key: "render",
      value: function () {
        this.material.uniforms.u_time.value = (this.material.uniforms.u_time.value + .002) % 1
      }
    }, {
      key: "dispose",
      value: function () {
        this.material = null
      }
    }]),
    r
}();
var t = { default: s }

export default t
